import { render, staticRenderFns } from "./ContasChavesPix.vue?vue&type=template&id=99cb9620&scoped=true&"
import script from "./ContasChavesPix.vue?vue&type=script&setup=true&lang=js&"
export * from "./ContasChavesPix.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cb9620",
  null
  
)

export default component.exports